import { getBrowser } from "../../config/global";
import { useSettingStore } from "../../store/modules/setting";
import { isMiniProgram, isMobile, isNN } from "../../utils/tools";

// 通用大小
export function getCompSize(sz) {
  //如果是drawer(也就是web版且是移动端），自动把所有组件改为小尺寸
  //原意：是控制分页器使用小尺寸然后让显示少点内容从而在移动端上能展示所有分页信息
  //目前使用：所有移动端web都使用小尺寸，后期看效果
  if (useSettingStore().layout !== 'drawer') {
    if (sz || sz >= 0) {
      return sz === 2 ? 'large' : sz === 0 ? 'small' : 'medium';
    }
    return 'medium';
  } else {
    return 'small'
  }
}


/** 生成样式（去掉-webkit类似）*/
export function genStyle(attr: any) {
  if (!attr) return {}

  let css = {};
  if (isMiniProgram() != 0) {
    Object.assign(css, attr['css']);
  } else {
    if (isMobile()) {//如果没有mcss，仍然使用css作为样式
      Object.assign(css, attr['mcss'] ? attr['mcss'] : attr['css']);
    } else {
      Object.assign(css, attr['css']);
    }
  }


  let webkitMoz = getBrowser();
  if (isNN(webkitMoz)) {
    let key = `vertical-align${webkitMoz}`;
    let val = css[key];
    if (isNN(val)) {
      css['vertical-align'] = val;
      delete css[key];
    }
  }
  delete css[''];//错误的属性

  return css;
}

/** 生成样式FrontContent/Dialog（去掉-webkit类似）*/
export function genStylex(css: any, mcss?: any) {

  let obj = {};
  if (isMobile()) {//如果没有mcss，仍然使用css作为样式
    Object.assign(obj, mcss ? mcss : css);
  } else {
    Object.assign(obj, css);
  }

  if (isNN(css)) {
    //   Object.assign(obj, css);
    let webkitMoz = getBrowser();
    if (isNN(webkitMoz)) {
      let key = `vertical-align${webkitMoz}`;
      let val = css[key];
      if (isNN(val)) {
        obj['vertical-align'] = val;
        delete obj[key];
      }
    }
    delete obj[''];//错误的属性
  }

  return obj;
}

//仅处理显式的false/true，其余不管（原来有可能就是none）
export function setDisplay(cssObj: any, display: boolean) {
  if (isNN(display)) {
    if (display === false) {
      cssObj['display'] = 'none';
    } else {
      cssObj['display'] = 'block';
    }
  }
  return cssObj;
}





//  解析 ———————— 转换css对象为css字符串  浏览器只支持元素css字符串，不支持css对象
function cssObjToText(obj = {}) {
  return Object.entries(obj).map(([k, v]) => {
    const cssKey = k.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
    return `${cssKey}:${v};`
  }).join('')
}


// 构建 class CSS
// 支持 SCSS 风格 "&" 选择器
//
// '&'                -> .className
// '&:hover'          -> .className:hover
// '& > .title'       -> .className > .title
// '& .item'          -> .className .item
// '&::before'        -> .className::before
// '& + .next'        -> .className + .next
// '& ~ .brother'      -> .className ~ .brother
// '&[disabled]'       -> .className[disabled]
function buildClassCss(classConfig) {
  if (!classConfig?.name || !classConfig?.rules) {
    return '';
  }

  const { name, rules } = classConfig;

  let cssText = '';
  for (const [selector, css] of Object.entries(rules)) {
    const fullSelector = selector.replaceAll('&', `.${name}`);
    cssText += `${fullSelector}{${cssObjToText(css)}}`;
  }

  return cssText
}



//暴露出去 追加class样式 支持所有原生css选择器
export function appendStyle(classConfig) {
  const styleId = `ts-style-${classConfig.name}`;

  let style = document.getElementById(styleId)
  //如果不存在则创建，如果是同名就会直接覆盖，这说明不同页面
  //之间可以使用相同的name，从而保证样式在新的页面渲染时能拿到最新的
  //同一个页面之内，不适合相同的name因为同一个页面如果相同覆盖，则会使用后面的样式
  if (!style) {
    style = document.createElement('style')
    style.id = styleId
    document.head.appendChild(style)
  }
  
  // 设置到页面上
  style.textContent = buildClassCss(classConfig)
}



/*
把解析好的样式插入到页面的style标签中
pseudo格式
{
  "hover": "color:#1890ff; cursor:pointer;",
  "active": "color:red;",
  "focus": "border-color:blue;"
}
// 伪类样式类名
let pseudoClassName = attr['pseudo'] ? getRandClassNamegetRandClassName() : undefined;

  if(attr['pseudo']){
  
    //pseudoClassName= getRandClassName();
    // updateDynamicStyles(refItem, (attr['pseudo']),pseudoClassName);
//   } 
//不能带. 且必须带随机数（否则list中渲染会重复）
export function getRandClassName() {
  return `c${new Date().getTime()}_${Math.floor(Math.random() * Math.floor(100))}`;
}
// export function updateDynamicStyles(self: any, pseudo: JSON, className: any) {
//     //可以异步，不需要立即处理
//     setTimeout(() => {
//         let rules: any = [];
//         Object.entries(pseudo).forEach(([key, value]) => {
//             // key = className
//             if (value && value.length > 0) {
//                 //第一个replace是为了转义css,防止css注入
//                 value = `${value}`.replace(/;/g, ' !important;').replace(/([\\])/g, '\\$1');
//                 //value = `${value}`.replace(/;/g, ' !important;').replace(/([\\;])/g, '\\$1');
//                 //value = `${value}`.replace(/([\\;{}])/g, '\\$1').replaceAll(';', ' !important;');
//                 rules.push(`.${className}:${key}{${value}}`);
//             }
//             //这种方式只能对单个样式逐个赋值，且value必须为字符串，效率未必好
//             //styleElement.setAttribute(`${className}${key}`, value);
//         });

//         if (rules.length === 0) {
//             return;
//         }

//         const styleElement: HTMLStyleElement = document.createElement<'style'>('style');
//         styleElement.textContent = rules.join('\n');
//         if (self.value && self.value.parentNode) {
//             self.value.parentNode.appendChild(styleElement);
//         } else {
//             ;//防止当前组件下不生效，要放到parent上
//         }
//     });
// }
*/